import axios from '../utils/axios'
import { FileError } from '../errors'

const uploadResume = (file, keepFormat, config = {}, feature = null) => {
    return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('keep_original_format', keepFormat)

        if (feature != null) {
            formData.append('feature', 'job-board')
        }

        axios.post('/api/resumes/upload', formData, config)
            .then(res => {
                resolve(res)
            }).catch((error) => {
                if (error?.response?.data) {
                    reject(new FileError(error.response.data.message, error.response.status))
                } else {
                    reject(new FileError('Failed to upload', 500))
                }
            }
            )
    })
}

export {
    uploadResume
}
